import ResponsiveTopAppBar from './ResponsiveTopAppBar'

export default ResponsiveTopAppBar
